import HomePage from "./home-page.vue";

const promise = new Promise(resolve => {
  vueApp.component('home-page', HomePage);
  resolve();
});

window.pendingComponentLoads.push(promise);